export class UserTagStatus {
    constructor() {
        this.INACTIVE = "INACTIVE";
        this.PRIVATE = "PRIVATE";
        this.PUBLIC = "PUBLIC";
        this.valid_statuses = ["INACTIVE","PRIVATE","PUBLIC"];
    }

    isValid(status) {
        return(!undefined(this.valid_statuses.find(status)));
    }
}

export class UserTag {
    constructor(tag) {
    }
}